<!-- LOADER :BEGIN -->

<div class="spinner-container" id="loader">

</div>

<!-- LOADER :END -->